export const firebaseConfig = {
  apiKey: "AIzaSyDqoomFJCmxYiHmmUL9h2ANDPAeQQA4Icg",
  authDomain: "turdle-efd37.firebaseapp.com",
  projectId: "turdle-efd37",
  storageBucket: "turdle-efd37.appspot.com",
  messagingSenderId: "699649629610",
  appId: "1:699649629610:web:4720f9689882232b025fd3",
}